<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-end">
        <v-flex xs12>
          <h3 class="text-center">Pharmacy Request</h3>
        </v-flex>
        <v-flex xs12 sm9 md6>
          <v-card>
            <v-card-title class="py-1">
              <v-btn small outlined color="error" @click="goTo('/pharmacy_requests/' + pharmacy_request.id + '/prescription')">
                <span v-if="!pharmacy_request.treatment">Add &nbsp;</span> Medication
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn small outlined title="Edit" color="orange" v-if="canEdit" @click="goTo('/pharmacy_requests/' + pharmacy_request.id + '/edit')">
                <v-icon left>mdi-content-save-edit</v-icon>Edit
              </v-btn>
            </v-card-title>
            <v-card-text>
              <show-request :pharmacy_request="pharmacy_request" :canEdit="canEdit"></show-request>
            </v-card-text>
            <v-card-actions class="py-0">
              <v-spacer></v-spacer>
              Created By: {{ user.name }}
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 class="pa-1">
          <v-card>
            <v-card-title class="py-1">
              Invoice
              <v-spacer></v-spacer>
              <v-btn small text outlined icon fab @click="addInvoice = !addInvoice" title="Add Invoice" color="green darken-2">
                <v-icon>mdi-cash-plus</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <invoices-table :invoices="invoices"></invoices-table>
            </v-card-text>
            <v-card-actions class="py-0">
              <p class="text-muted">This is only the invoice for the pharmacy request. The actual prescription has a different invoice. If you wish to combine, the invoices, Make an invoice for the prescription for nil amount, Create an invoice for the drugs and request here.</p>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <mk-dialog v-model="addInvoice">
        <template #title>Add Invoice <v-icon>mdi-cash</v-icon></template>
        <v-card>
          <v-card-text>
            <form @submit.prevent="saveInvoice(invoice)">
              <v-text-field :label="'Date (default: ' + moment().format('ll')  + ')'" v-model="invoice.date" type="date"></v-text-field>
              <v-text-field label="Description" v-model="invoice.description" placholder="Invoice for Pharmacy Request" :counter="60" maxlength="60"></v-text-field>
              <v-text-field label="Amount" type="number" steps="0.01" v-model="invoice.net" required="required"></v-text-field>
              <v-btn small type="submit" color="primary" class="pull-right" :loading="invoice.processing">
                <v-icon left>mdi-content-save</v-icon>Save
              </v-btn>
              <br>
            </form>
          </v-card-text>
        </v-card>
      </mk-dialog>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const ShowRequest = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "pharmacy-requests" */ '@/Components/PharmacyRequests/show')
  const InvoicesTable = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "pharmacy-requests" */ '@/Components/Invoices/invoices')
  const MkDialog = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/mk-dialog')

  export default {
    name: 'ShowPharmacyRequest',
    layout,
    props: [
      'pharmacy_request', 'canEdit'
    ],
    components: {
      MkDialog,
      ShowRequest,
      InvoicesTable,
    },
    metaInfo () {
      return {
        title: 'Pharmacy Request',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        addInvoice: false,
        invoice: this.$inertia.form({
          net: '',
          description: '',
          date: ''
        })
      }
    },
    computed: {
      user () {
        return this.pharmacy_request.user
      },
      invoices () {
        return this.pharmacy_request.invoices
      }
    },
    methods: {
      saveInvoice (invoice) {
        this.invoice.post('/pharmacy_requests/' + this.pharmacy_request.id + '/invoices', {
          onSuccess: () => {
            this.addInvoice = false
            swal({ title: 'Saved', type: 'success', timer: 2500 })
          }
        })
      }
    }
  }
</script>

<style>
   /**/
</style>
